import React from 'react'
import { Box, CheckBox } from '@usap/uicomponents'

const ComputeQtyCheckbox = props => {
  const {
    isMultiplePart,
    itemOrderId,
    showCheckBox,
    handleChange,
    qtyToCompute,
  } = { ...props }
  return (
    <>
      {isMultiplePart && showCheckBox && (
        <Box
          alignSelf="start"
          justify="center"
          margin={{ horizontal: '10px', top: '32px', bottom: '10px' }}
          width="25px"
        >
          <CheckBox
            name={`RMA${itemOrderId}`}
            onChange={e => handleChange(e)}
            value={qtyToCompute}
          />
        </Box>
      )}
    </>
  )
}

export default ComputeQtyCheckbox
